import Index from "./navigation";

function App() {
  return ( 
    <Index/>
  );
}

export default App;
